import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useStore } from '../context/StoreContext';
import { api } from '../services/api';
import { getPendingRequest, pendingEvent } from '../services/pendingRequests';

export const PendingRequestNotice = () => {
  const { user, refreshData } = useStore();
  const location = useLocation();
  const companyId = user?.companyId || location.pathname.match(/^\/loja\/([^/]+)/)?.[1];
  const [pending, setPending] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    const update = () => setPending(Boolean(companyId && getPendingRequest(companyId)));
    update();
    window.addEventListener(pendingEvent, update);
    window.addEventListener('storage', update);
    return () => { window.removeEventListener(pendingEvent, update); window.removeEventListener('storage', update); };
  }, [companyId]);
  if (!pending) return null;
  return <aside role="alert" className="fixed top-2 left-1/2 -translate-x-1/2 z-[99999] max-w-xl w-[95%] rounded-xl bg-amber-100 text-amber-950 border border-amber-400 p-3 shadow-lg print:hidden">
    <strong>Envio aguardando confirmação</strong>
    <p className="text-sm">Não lance novamente. O envio está guardado neste navegador e pode ser recuperado sem duplicar.</p>
    {error && <p className="text-sm">{error}</p>}
    <button disabled={busy} className="mt-2 rounded bg-slate-950 px-3 py-2 text-white disabled:opacity-50" onClick={async () => {
      if (!companyId || busy) return;
      setBusy(true); setError('');
      try { await api.recoverPending(companyId); if (user) await refreshData(); }
      catch (failure: any) { setError(failure.message); }
      finally { setBusy(false); }
    }}>{busy ? 'Confirmando...' : 'Recuperar envio'}</button>
  </aside>;
};
